import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { Specialization, CacheService, ITypeSpecialityBO } from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class SpecializationService {

  className = 'SpecializationService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllSpecializations(cache = true, cacheKey = "allSpecializations"): Observable<ITypeSpecialityBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeSpecialityBO[]>;
    } else {
      const observable = this.http.get<ITypeSpecialityBO[]>(environment.base_URL + "/types-speciality").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newSpecialization(specializations: ITypeSpecialityBO): Observable<ITypeSpecialityBO[]> {
    return this.http.post<ITypeSpecialityBO[]>(environment.base_URL + "/types-speciality", specializations).pipe(tap(() => this.deleteCache()))
  }

  updateSpecialization(specializations: ITypeSpecialityBO, id: number): Observable<ITypeSpecialityBO[]> {
    return this.http.put<ITypeSpecialityBO[]>(environment.base_URL + `/types-speciality/${id}`, specializations).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    this.cacheService.deleteCache('allSpecializations');
  }
}

